export default "__VITE_ASSET__A32hYazk__"